export default __webpack_public_path__ + "static/media/GA_Zoom-1.3eb110b0.wav";